(function(){
  if(window.rlShare) return;
  window.rlShare = true;

  var canNative = !!(navigator.share);

  function init(){
    document.querySelectorAll('[data-share-root]').forEach(function(root){
      if(root.dataset.ready) return;
      root.dataset.ready = '1';

      var nativeBtn = root.querySelector('[data-share-native]');
      var fallback = root.querySelector('[data-share-fallback]');

      /* phones get the system sheet; desktop keeps the explicit icons */
      if(canNative){
        if(fallback) fallback.hidden = true;
        if(nativeBtn) nativeBtn.hidden = false;
      } else {
        if(nativeBtn) nativeBtn.hidden = true;
        if(fallback) fallback.hidden = false;
      }
    });
  }

  document.addEventListener('click', function(e){
    if(!e.target.closest) return;

    var nat = e.target.closest('[data-share-native]');
    if(nat){
      e.preventDefault();
      navigator.share({
        title: nat.getAttribute('data-title') || document.title,
        text: nat.getAttribute('data-text') || '',
        url: nat.getAttribute('data-url') || location.href
      }).catch(function(){});
      return;
    }

    var copy = e.target.closest('[data-share-copy]');
    if(copy){
      e.preventDefault();
      var url = copy.getAttribute('data-url') || location.href;
      var done = function(){
        copy.classList.add('is-done');
        var lbl = copy.querySelector('[data-copy-label]');
        if(lbl){
          var was = lbl.textContent;
          lbl.textContent = 'Copied';
          setTimeout(function(){ lbl.textContent = was; }, 1800);
        }
        setTimeout(function(){ copy.classList.remove('is-done'); }, 1800);
      };
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(url).then(done).catch(function(){});
      } else {
        var t = document.createElement('textarea');
        t.value = url;
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); done(); } catch(err){}
        document.body.removeChild(t);
      }
    }
  });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
